import { RouteComponent } from "router/index";

export function getNewClauseName(type: RouteComponent) {
  let typeUpdate = type;
  if (type === RouteComponent.CustomClauses) {
    typeUpdate = RouteComponent.Clauses;
  }

  // Handle special cases where we don't want to remove the last character
  if (type === RouteComponent.Policies) {
    return typeUpdate.toLowerCase(); // Return "policy" as is
  }

  return typeUpdate.slice(0, -1).toLowerCase();
}
